import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Users, GraduationCap, FileText } from 'lucide-react';

const ExportCSVModal = ({ isOpen, onClose, onExport }) => {
    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95, y: 20 }}
                    className="bg-slate-900 border border-white/10 rounded-3xl w-full max-w-md shadow-2xl overflow-hidden"
                >
                    {/* Header */}
                    <div className="p-6 border-b border-white/5 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-xl bg-primary/10 text-primary">
                                <FileText size={24} />
                            </div>
                            <h3 className="text-xl font-bold text-white">Exporter en CSV</h3>
                        </div>
                        <button 
                            onClick={onClose} 
                            className="text-slate-400 hover:text-white transition-colors p-2 hover:bg-white/5 rounded-full"
                        >
                            <X size={20} />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="p-6 space-y-4">
                        <p className="text-slate-400 text-sm mb-6">
                            Sélectionnez le type de comptes que vous souhaitez exporter dans le fichier CSV.
                        </p>

                        <button
                            onClick={() => {
                                onExport(false);
                                onClose();
                            }}
                            className="w-full flex items-center gap-4 p-4 rounded-2xl border border-white/5 bg-white/5 hover:bg-white/10 hover:border-primary/50 transition-all group text-left"
                        >
                            <div className="p-3 rounded-xl bg-blue-500/10 text-blue-500 group-hover:scale-110 transition-transform">
                                <Users size={28} />
                            </div>
                            <div>
                                <h4 className="text-white font-bold text-lg">Tous les comptes</h4>
                                <p className="text-slate-400 text-sm">Exporte l'intégralité de la base des membres</p>
                            </div>
                        </button>

                        <button
                            onClick={() => {
                                onExport(true);
                                onClose();
                            }}
                            className="w-full flex items-center gap-4 p-4 rounded-2xl border border-white/5 bg-white/5 hover:bg-white/10 hover:border-amber-500/50 transition-all group text-left"
                        >
                            <div className="p-3 rounded-xl bg-amber-500/10 text-amber-500 group-hover:scale-110 transition-transform">
                                <GraduationCap size={28} />
                            </div>
                            <div>
                                <h4 className="text-white font-bold text-lg">Seulement les étudiants</h4>
                                <p className="text-slate-400 text-sm">Filtre uniquement les comptes avec le rôle "Étudiant"</p>
                            </div>
                        </button>
                    </div>

                    {/* Footer */}
                    <div className="p-4 bg-black/20 border-t border-white/5 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-6 py-2 text-slate-400 hover:text-white font-medium transition-colors"
                        >
                            Annuler
                        </button>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default ExportCSVModal;
